import { EColors, EFonts, EVariables } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  title: string
  children?: React.ReactNode
  className?: string
  id?: string
}

export const SplitTitle = (props: Props): JSX.Element => {
  return (
    <S_SplitTitle className={props.className} id={props.id}>
      <S_Title>{props.title}</S_Title>
      {props.children && <S_Desc>{props.children}</S_Desc>}
    </S_SplitTitle>
  )
}

const S_SplitTitle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

const S_Title = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Bold};
  font-size: 32px;
  letter-spacing: ${EVariables.Spacing};
  @media only screen and (min-width: 1260px) {
    font-size: 37px;
  }
`

const S_Desc = styled.div`
  color: ${EColors.DARK2};
  font-family: ${EFonts.Medium2};
  font-size: 15px;
  line-height: 28px;
  margin: 13px 0 0 0;
  padding: 0 20px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    line-height: 37px;
    margin: 20px 0 0 0;
  }
`
